import request from '@/utils/request' //引入封装好的 axios 请求

export function addNews(newsTitle, newsIntroduction,photo,newsAuthor,createTime,updateTime,newsContent) {
  return request({
    url: '/news/addNews',
    method: 'post',
    data: {
     //标题
  newsTitle,
  //简介
  newsIntroduction,
  //缩略图
  photo,
  //新闻作者Id
  newsAuthor,
  //创建时间
  createTime,
  newsContent,
  //修改时间暂存token
  updateTime
    }
  })
}